module.exports = __webpack_public_path__ + "img/icon_location_busy.e09ec875.png";